/**
 * @fileoverview Agent definition for world-system-ideation-v3.
 *
 * This agent generates ideas for world systems (magic systems, natural laws,
 * social customs, technologies, materials) that govern how the story world works.
 *
 * @category world-building.systems.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-system-ideation-v3',
  kind: 'primitive',
  name: 'World System Ideation',
  description: 'Generates ideas for world systems (magic systems, natural laws, social customs, technologies, materials) that govern how the story world works.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.systems.creation',
    usedBy: ['use-world-system-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-system-details-ideation-v3',
      'world-system-details-generator-v3',
    ],
  },
};
